export default "__VITE_ASSET__tOW_QoPn__"